import { FaxSentStatus } from "../../../enums/faxStatus";

export enum FaxSubmissionStatus {
  FAX_SUBMITTED = "fax_submitted",
  FAX_ERROR = "fax_error",
  FAX_DELIVERED = "fax_delivered",
  FAX_FAILED = "fax_failed",
  IN_PROGRESS = "in_progress",
  SUBMISSION_COMPLETED = "submission_completed",
}

/**
 * Maps fax submission status to the correct order status
 * @param status - The fax sent status
 * @returns The corresponding order status
 */
export const getCorrectStatusBasedOnFaxSubmissionStatus = (
  status: string,
): string => {
  if (status === FaxSentStatus.SENT) {
    return FaxSubmissionStatus.FAX_SUBMITTED;
  } else if (status === FaxSentStatus.FAILED) {
    return FaxSubmissionStatus.FAX_ERROR;
  } else {
    return FaxSubmissionStatus.IN_PROGRESS;
  }
};
